import { MUTATIONS } from './constants'
import { defaultFilters } from './filtersDefinition'

export const mutations = {
  [MUTATIONS.SET_FILTER_VALUE] (state, { key, value }) {
    state.filters = state.filters.map(f => {
      if (f.key === key) {
        f.value = value
      }
      return f
    })
  },
  [MUTATIONS.SET_POIS_FILTER_VALUE] (state, { value }) {
    state.localPoisTextSearch = value
  },
  [MUTATIONS.SET_ADVERTS_FILTER_VALUE] (state, { value }) {
    state.localAdvertsTextSearch = value
  },
  [MUTATIONS.SET_SHOPS_FILTER_VALUE] (state, { value }) {
    state.localShopsTextSearch = value
  },
  [MUTATIONS.UPDATE_FILTER_DEF] (state, newFilter) {
    state.filters = state.filters.map(oldFilter => {
      if (oldFilter.key === newFilter.key) {
        let value = oldFilter.value
        if (oldFilter.multiple && !newFilter.multiple) {
          value = value[0] || null
        }
        if (newFilter.multiple && !oldFilter.multiple) {
          value = value ? [value] : []
        }
        return { ...oldFilter, value, ...newFilter }
      }
      return oldFilter
    })
  },
  [MUTATIONS.CLEAR_GROUP] (state, group) {
    state.filters = state.filters.map(f => {
      if (group.filters.indexOf(f) !== -1) {
        f.value = f.multiple ? [] : null
      }
      return f
    })
  },

  [MUTATIONS.CLEAR_ALL_FILTERS] (state) {
    state.filters = defaultFilters()
  },
  [MUTATIONS.SET_ACTIVE_GROUPS] (state, payload) {
    state.activeGroups = payload
  },
  [MUTATIONS.CLEAR_TEXT_FILTERS] (state) {
    state.localPoisTextSearch = ''
    state.localAdvertsTextSearch = ''
    state.localShopsTextSearch = ''
  }
}
